import { render, staticRenderFns } from "./IbYesNoCancelModal.vue?vue&type=template&id=0dd1465a"
import script from "./IbYesNoCancelModal.vue?vue&type=script&lang=js"
export * from "./IbYesNoCancelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports